import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { UserApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  View_data: null,
  incentive_list: null
};

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserGrid(state, action) {
      state.list_data = action.payload;
    },
    setUserViewGrid(state, action) {
      state.View_data = action.payload;
    },
    setIncentiveGrid(state, action) {
      state.incentive_list = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// User List
export const getUserList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: UserApi?.UserList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setUserGrid(res?.data?.data || []));
      return res?.data;
    } else {
      dispatch(setUserGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Sales List failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Sales List exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// User view
export const getUserViewList = (endpoint) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: endpoint,
      method: 'get'
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setUserViewGrid(res?.data || []));
      return res?.data;
    } else {
      dispatch(setUserGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Sales view failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Sales view exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// incentive list
export const getIncentiveList = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: `${UserApi?.incentiveList}/${id}`,
      method: 'get'
    });

    // console.log('slice incentive data', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setIncentiveGrid(res?.data?.summary?.incentives || []));
      return res?.data;
    } else {
      dispatch(setIncentiveGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ incentive list failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 incentive list exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setUserGrid, setUserViewGrid, setIncentiveGrid } = UserSlice.actions;
export default UserSlice.reducer;
